/*
Sohel 03/21/2023 2699762545 Add validation in Letter Group
Sohel 03/23/2023 2699762545 Payload Changes
Guru Prasad 03/23/2023 2699762545 Fixed scrolling issues
Prakash 03/24/2023 2699762545 Fixed responsive issue width.
Guru Prasad 04/03/2023 2699762545 Fixed column spacing issues
Sohel 04/08/2023 2699762545 Added Letter Type in Payload
Sohel 04/10/2023 3225736869 Fixed Letter Type Payload Changes
*/
import React, {useEffect, useContext, useRef} from 'react';
import {Formik} from 'formik';
import {Button, FormHelperText, TextField} from '@material-ui/core';
import {ThemeContext} from '../../../../themes/ThemeProvider';
import {codeRegex} from '../../../../util/RegexPatterns';
import {codeValidationMessage} from '../../../../util/Content';
import * as Yup from 'yup';
import {
  fetchAllLetterGroupCode,
  postNewLetterGroup,
  resetBasicInfo,
} from '../../../../redux/reducers/LetterMaintainance/NewLetterMaintenance';
import {useSelector, useDispatch} from 'react-redux';
const AddLetterGroup = ({handleClose, setLetterGroupCode, saveRef}) => {
  const dispatch = useDispatch();
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();
  const formRef = useRef();
  const initialState = {
    code: '',
    description: '',
  };
  const {
    basicInfoSuccessMsg,
    basicInfoErrorMsg,
    basicInfoStatus,
    basicInfoData,
    allLetterGroupCode,
  } = useSelector(({newLetterMaintenance}) => newLetterMaintenance);

  const handleSubmit = (values) => {
    const payload = {
      deleteIds: [0],
      isDarft: 'N',
      lastStep: 0,
      letterType: basicInfoData?.letterType ? basicInfoData?.letterType : '',
      letterGroupCode: values?.code ? values?.code : '',
      letterGroupDescription: values?.description ? values?.description : '',
      letterGroupItemResponse: [
        // {
        //   letterCode: basicInfoData?.letterCode ? basicInfoData?.letterCode : "",
        //   letterDescription: basicInfoData?.letterDescription
        //     ? basicInfoData?.letterDescription
        //     : "",
        //   letterGroupCode: values?.code ? values?.code : "",
        //   letterGroupItemsId: 0,
        // },
      ],
    };
    dispatch(postNewLetterGroup(payload));
  };
  useEffect(() => {
    if (basicInfoSuccessMsg || basicInfoErrorMsg) {
      setTimeout(() => {
        if (basicInfoSuccessMsg && basicInfoStatus === 200) {
          setLetterGroupCode(formRef?.current?.values?.code);
          if (basicInfoData?.letterType) {
            const letterType = basicInfoData?.letterType?.replace(' ', '_');
            dispatch(fetchAllLetterGroupCode(letterType));
          }

          handleClose();
        }
        dispatch(resetBasicInfo());
      }, 2000);
    }
  }, [basicInfoErrorMsg, basicInfoSuccessMsg, basicInfoStatus]);

  const checkRecordCodeAlreadyExist = (value) => {
    if (allLetterGroupCode && allLetterGroupCode?.length > 0 && value) {
      const ar = [];
      allLetterGroupCode.filter((i) => {
        if (i?.letterGroupCode?.toUpperCase()?.trim() === value?.toUpperCase()?.trim()) {
          ar.push(i);
        }
      });
      return ar.length > 0;
    } else {
      return false;
    }
  };

  const schema = Yup.object().shape({
    code: Yup.string()
      .required('Letter Group Code is required')
      .matches(codeRegex, codeValidationMessage)
      .test(
        'code',
        'Letter Group Code already exist',
        (value) => !checkRecordCodeAlreadyExist(value),
      ),
    description: Yup.string().required('Letter Group Code Description is required'),
  });
  return (
    <>
      <Formik
        onSubmit={(values) => handleSubmit(values)}
        initialValues={initialState}
        enableReinitialize
        validationSchema={schema}
        innerRef={formRef}
      >
        {(props) => {
          const {
            values,
            handleBlur,
            handleReset,
            handleSubmit,
            setFieldValue,
            touched,
            errors,
            submitForm,
          } = props;
          return (
            <form autoComplete="off" noValidate onSubmit={handleSubmit}>
              <div className="form-row col-12 mt-2 standard-field-textfields new-standard-textfields">
                <div className="col-sm-6 col-md-6 col-xl-6 form-group">
                  <TextField
                    margin="dense"
                    variant="outlined"
                    className={` ${classes.labelName}`}
                    placeholder={`Enter Letter Group Code`}
                    label="Letter Group Code"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    name="code"
                    required
                    // disabled={Boolean(eventTacticData?.code)}
                    value={values?.code?.toUpperCase()}
                    onChange={(e) => {
                      setFieldValue('code', e.target.value);
                    }}
                    onBlur={handleBlur}
                    fullWidth
                    touched={touched.code}
                    error={Boolean(touched.code && errors.code)}
                  />
                  <FormHelperText>{touched.code && errors?.code && errors.code}</FormHelperText>
                </div>
                <div className="col-sm-6 col-md-6 col-xl-6 form-group">
                  <TextField
                    margin="dense"
                    variant="outlined"
                    placeholder={`Enter Letter Group Code Description`}
                    className={` ${classes.labelName}`}
                    label="Letter Group Code Description"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    name="description"
                    required
                    value={values?.description}
                    onChange={(e) => {
                      setFieldValue('description', e.target.value);
                    }}
                    onBlur={handleBlur}
                    fullWidth
                    touched={touched.description}
                    error={Boolean(touched.description && errors.description)}
                  />
                  <FormHelperText>
                    {touched.description && errors?.description && errors.description}
                  </FormHelperText>
                </div>
              </div>
              <div className=" d-flex justify-content-center new-standard-textfields">
                <Button
                  variant="outlined"
                  className={`mr-1 reset-btn`}
                  onClick={() => {
                    handleReset();
                  }}
                >
                  Reset
                </Button>
                <Button
                  type="button"
                  variant="outlined"
                  className={`ml-1 search-btn`}
                  onClick={() => {
                    saveRef.current = true;
                    submitForm();
                  }}
                >
                  Save
                </Button>
              </div>
            </form>
          );
        }}
      </Formik>
    </>
  );
};

export default AddLetterGroup;
